<!--记工统计-工人-->
<template>
  <div class="content" v-loading="loading">
    <div class="list">
      <BaseEmptyData v-if="!list.length"/>
      <div class="card" v-for="item in list" :key="item.workerName">
        <header>{{ item.workerName }}</header>
        <div class="card_content">
          <el-row class="point_wrap">
            <el-col :span="12" class="work_type">
              点工
            </el-col>
            <el-col :span="12" class="work_rules">
              <div style="margin-bottom:16px">
                <span class="color666">上班：</span>{{ handleWorkText(item) }}
              </div>
              <div>
                <span class="color666">加班：</span>{{ item.workOverHourAll ? item.workOverHourAll + '小时' : '无加班' }}
              </div>
            </el-col>
          </el-row>
          <div class="hr_dashed"></div>
          <div class="bao_wrap" style="display: flex;overflow: hidden">
            <div style="width: 8em;white-space:nowrap;margin-right: 2em">包工(按量计)</div>
            <div style="width: 6em;white-space:nowrap;margin-right: 2em">{{ item.wrapWorkNum }}笔</div>
            <div style="flex:1;white-space:nowrap;text-align: right" class="salary">￥{{ item.salaryAll.toFixed(2) }} 元
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {api} from "@/api/apiRecord.js"

export default {
  name: "CountWorker",
  components: {
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"), // 无数据组件
  },
  props: {
    project: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      list: [],
      loading: false
    }
  },
  methods: {
    /**
     * 获取记工统计-工人 列表
     * @param projectNo {String} 项目no
     * */
    async getList(projectNo) {
      this.loading = true
      const params = {
        "dimension": "1",
        "projectNo": projectNo || this.project.projectNo,
        "recordType": this.$route.query.type ? this.$route.query.type : '1'
      }
      const res = await api.getWorkStatistics(params)
      if (res.data.code === 200) {
        const pointArr = res.data.data.pointWorkStatisticsList
        const wrapArr = res.data.data.wrapWorkStatisticsList
        const pointNames = [...new Set(pointArr.map(item => item.workerName))]
        const wrapNames = [...new Set(wrapArr.map(item => item.workerName))]

        let renderArr = []
        const names = [...new Set([...pointNames, ...wrapNames])]
        names.forEach(item => {
          let obj = {
            projectName: "",
            projectNo: "",
            workDayAll: 0,
            workHourAll: 0,
            workOverHourAll: 0,
            workerName: item,
            salaryAll: 0,
            wrapWorkNum: 0
          }
          pointArr.forEach(v => {
            if (item === v.workerName) {
              obj.projectName = v.projectName
              obj.projectNo = v.projectNo
              obj.workDayAll += v.workDayAll
              obj.workHourAll += v.workHourAll
              obj.workOverHourAll += v.workOverHourAll
            }
          })
          wrapArr.forEach(v => {
            if (item === v.workerName) {
              obj.projectName = v.projectName
              obj.projectNo = v.projectNo
              obj.salaryAll += v.salaryAll
              obj.wrapWorkNum += v.wrapWorkNum
            }
          })

          renderArr.push(obj)
        })

        this.list = renderArr
      }
      this.loading = false
    },
    /**
     * 处理上班时长文本
     * @param workerInfo {Object} 包含工人点工包工信息的对象
     * @return {String} 处理以后的上班时长文本
     * */
    handleWorkText(workerInfo) {
      const day = workerInfo.workDayAll ? workerInfo.workDayAll + '个工' : ''
      const hour = workerInfo.workHourAll ? workerInfo.workHourAll + '小时' : ''
      if (day && hour) {
        return `${day}, ${hour}`
      }
      return (day + hour) || '休息'
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  .list {
    padding: 20px;
    max-height: 557px;
    overflow-y: auto;


    .card {
      border: 1px solid #E4E7ED;
      border-radius: 2px;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    header {
      padding: 0 10px;
      line-height: 40px;
      background: #F5F7FA;
    }

    .card_content {
      padding: 20px 10px;
      color: #333;

      .work_type {
        line-height: 48px;
      }

      .salary {
        color: #FF6600;
        font-size: 16px;
      }
    }

    .hr_dashed {
      border-top: 1px dashed #E4E7ED;
      margin: 20px 0;
    }
  }
}
</style>
